const ListingDeliveryStatus = Object.freeze({
  Delivered: {
    name: 'Delivered',
    value: 'delivered',
    color: 'success',
  },
  Undelivered: {
    name: 'Undelivered',
    value: 'undelivered',
    color: 'critical',
  },
  Scheduled: {
    name: 'Scheduled',
    value: 'scheduled',
    color: 'warning',
  },
})

export default ListingDeliveryStatus
